/* eslint-disable max-len */
import { vuexErrorHandler } from '@switchsystems/coactive-vue-lib';
import { Auth } from 'aws-amplify';

const modulestate = () => ({
  /**
   * The email address a user is currently registering under
   */
  email: '',
  registrationStep: 0,
  signupResult: {}, // ISignUpResult
});
const getters = {
  email: (state) => state.email,
  signupResult: (state) => state.signupResult,
  registrationStep: (state) => state.registrationStep,
};
const mutations = {
  updateEmail(state, email) {
    state.email = email;
  },
  updateRegistrationStep(state, registrationStep) {
    state.registrationStep = registrationStep;
  },
  updateSignupResult(state, result) {
    state.signupResult = result;
  },
  resetStateAfterSuccessfulLogin(state) {
    state.email = '';
    state.registrationStep = 0;
    state.signupResult = {};
  },
};
const actions = {
  async step1(context, payload) {
    context.commit('updateEmail', payload.email);

    const result = await Auth.signUp({
      username: payload.email,
      password: payload.password,
    });

    context.commit('updateRegistrationStep', 1);
    context.commit('updateSignupResult', result);
    return true;

    /*
    result should be something like this:

    "user": {
      "username": "kris@techexeter.uk",
      "pool": {
          "userPoolId": "eu-west-2_bzCIzPBUf",
          "clientId": "249bl01e8tihuduo2oicnun78o",
          "client": {
              "endpoint": "https://cognito-idp.eu-west-2.amazonaws.com/",
              "fetchOptions": {}
          },
          "advancedSecurityDataCollectionFlag": true
      },
      "Session": null,
      "client": {
          "endpoint": "https://cognito-idp.eu-west-2.amazonaws.com/",
          "fetchOptions": {}
      },
      "signInUserSession": null,
      "authenticationFlowType": "USER_SRP_AUTH",
      "keyPrefix": "CognitoIdentityServiceProvider.249bl01e8tihuduo2oicnun78o",
      "userDataKey": "CognitoIdentityServiceProvider.249bl01e8tihuduo2oicnun78o.kris@techexeter.uk.userData"
    },
    "userConfirmed": false,
    "userSub": "85dc9f95-3fb8-43f5-80d5-ecc513be937b",
    "codeDeliveryDetails": {
        "AttributeName": "email",
        "DeliveryMedium": "EMAIL",
        "Destination": "k***@t***.uk"
    }

    */
  },
  async step2(context, payload) {
    const confirmResult = await Auth.confirmSignUp(payload.username, payload.confirmationCode);

    if (confirmResult === 'SUCCESS') {
      context.commit('updateRegistrationStep', 2);
      return true;
    }
    vuexErrorHandler({ message: confirmResult });
    return false;
  },
  async resendConfirmation(context, email) {
    await Auth.resendSignUp(email);
  },
};

export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state: modulestate,
};
